import { orchestrator } from 'satcheljs';
import { updateNumDaysInDayRange } from '../actions/updateNumDaysInDayRange';
import { updateNumDaysInDayRangeServerValue } from '../utils/updateFlexibleDayViewValues';
import { resetNumDaysInDayRange } from '../actions/resetNumDaysInDayRange';
import { logUsage } from 'owa-analytics';

orchestrator(updateNumDaysInDayRange, actionMessage => {
    const { newValue, isUserChange } = actionMessage;
    // only log if this is a user change, since we get the persisted state logged in InitialCalendarSurfaceOptions
    if (isUserChange) {
        logUsage('updateNumDaysInDayRange', { numDaysInDayRange_1: newValue }, { isCore: true });
    }
    updateNumDaysInDayRangeServerValue(newValue);
});

orchestrator(resetNumDaysInDayRange, actionMessage => {
    // only log if this is a user change, since we get the persisted state logged in InitialCalendarSurfaceOptions
    if (actionMessage.isUserChange) {
        logUsage('updateNumDaysInDayRange', { numDaysInDayRange_1: 1 }, { isCore: true });
    }
    updateNumDaysInDayRangeServerValue(1);
});
